import { useEffect } from "react";
import { getlistAmount } from "../store/slices/listAmountSlice";
import { useDispatch, useSelector } from "react-redux";

export const useListAmount = () => {
  const dispatch = useDispatch();
  const listAmountData = useSelector((state) => state.listAmount);
  const authStatus = useSelector((state) => state.token.status);

  useEffect(() => {
    if (authStatus === "succeeded" && listAmountData.status === "idle") {
      dispatch(getlistAmount());
    }
  }, [authStatus]);

  return {
    listAmountData: listAmountData?.listAmountData,
  };
};
